export class Carrito {

    constructor(
        public id: number,
        public urlImagen: string,
        public nombre: string,
        public precio: number,
        public cantidad: number,
        public esServicio: boolean


    ) {}


}
